/* eslint-disable @typescript-eslint/no-explicit-any */
import type { Theme } from "@mui/material/styles";

export default function Radio(theme: Theme): any {
  return { MuiRadio: { styleOverrides: { root: { padding: theme.spacing(1) } } } };
}
